import service from '@/api/action';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../generators/helpers";

export const state = {
    service: service('actions')
}

export const getters = {}

export const mutations = {}

export const actions = {
    create: function ({commit, state, /*dispatch*/}, payload) {
        loading(commit)

        return state.service.store(payload).then(data => {
            const model = Object.assign({}, payload, data.data);

            commit('ADD_ITEM', model);
            commit('SET_ITEM', model);
            alert(commit, this.$t('request.creation_is_successful'));
            commit('SET_ERRORS', {});
            // dispatch('all', state.allQuery);

            loading(commit, false)

            return {model: model, token: data.token};
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
